<template>
    <info-widget :collapsible="true" :is-expanded="expanded" @toggle_expand="$emit('toggle_expand')">
        <template v-slot:title>Emergency Contacts</template>
        <template v-slot:headerbutton v-if="employee.is_employee && $permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.ONBOARDING_ROLES)">
            <button class="btn btn-outline-primary" type="button" @click.stop.prevent="openEmergencyContactModal">
                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                Edit
            </button>
        </template>

        <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.ONBOARDING_ROLES)">
            <div class="info-widget-empty p-2">
                This information is not available to your security role.
            </div>
        </slot>

        <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.ONBOARDING_ROLES)">
            <div v-if="emergencyContacts.length">
                <section class="table-section">
                    <table class="table css-table widget-table table-fixed">
                        <thead>
                            <tr>
                                <th class="cw-toggle"></th>
                                <th>Name</th>
                                <th>Relationship</th>
                            </tr>
                        </thead>
                        <tbody v-for="contact in emergencyContacts">
                        <!-- Start of an individual contact -->
                            <tr class="mb-2">
                                <td class="cw-toggle position-relative">
                                    <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': expandedEmergencyContacts[contact.id]}" @click.prevent="expandedEmergencyContacts[contact.id] = !expandedEmergencyContacts[contact.id]">
                                        <collapse-toggle-button />
                                    </a>
                                </td>
                                <td class="truncate-wrapper">
                                    <span class="truncate-content"> <!-- Unsure if truncate-content is truly required here, but I think so -->
                                        {{ contact.full_name }}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{ contact.relationship }}
                                    </span>
                                </td>
                            </tr>

                            <tr class="child no-transition" v-show="expandedEmergencyContacts[contact.id]">
                                <td colspan="3" class="normal-size">
                                    <ul class="list-unstyled m-0 ml-3" style="padding-left: 4px">
                                        <li v-if="contact.phone">
                                            <i class="fas fa-phone text-muted mr-1"></i>
                                            <a :href="'tel:' + contact.phone">{{ contact.phone_formatted }}</a>
                                        </li>
                                        <li v-if="contact.email">
                                            <i class="fas fa-envelope text-muted mr-1"></i>
                                            <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        <!-- End of an individual contact -->
                        </tbody>
                    </table>
                </section>
            </div>
            <div v-if="!emergencyContacts.length">
                <div class="info-widget-empty p-2">
                    This employee has no emergency contacts.
                </div>
            </div>

        </slot>

    </info-widget>

    <emergency-contact-modal :client="client" :employee="employee" :contacts="emergencyContacts" @updated="onEmergencyContactsUpdate" ref="emergencyContactModal" v-if="emergencyContactModalOpen" @close="emergencyContactModalOpen = false" />
</template>

<script>
import ButtonRow from '@/components/ButtonRow'
import InfoWidget from '@/components/InfoWidget'

import EmergencyContactModal from './EmergencyContactEditModal'

export default {
    components: {ButtonRow, InfoWidget, EmergencyContactModal},
    props: ['employee', 'client', 'emergencyContacts', 'expanded'],
    emits: ['updated', 'toggle_expand'],
    computed: {

    },
    data() {
        return {
            emergencyContactModalOpen: false,
            expandedEmergencyContacts: {},
        }
    },
    methods: {
        // Below function added for testing
        openEmergencyContactModal() {
            this.emergencyContactModalOpen = true
            this.$nextTick(() => {
                this.$refs.emergencyContactModal.open()
            })
        },
        onEmergencyContactsUpdate(resp) {
            this.$emit('updated', resp)
        }
    },
}
</script>
